var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagoneBasiqueReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.941,
    height: 242.941,
    viewBox: "0 0 242.941 242.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242.941,
    height: 242.941,
    rx: 55.382,
    ry: 55.382
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.187,75.181c-.03,2.43,1.22,4.58,3.34,5.75l36.86,20.4c1.62.9,2.63,2.58,2.63,4.39v4.21c0,1.69-.87,3.27-2.32,4.2l-.93.61c-1.28.82-2.72,1.23-4.18,1.23-1.3,0-2.6-.33-3.78-.99l-51.29-28.96c-2.06-1.16-4.52-1.17-6.58-.04l-25.65,14.04c-1.66.91-3.63.88-5.26-.08-1.55-.93-2.49-2.54-2.49-4.32v-4.48c0-1.78.98-3.44,2.55-4.35l60.17-34.61c2.33-1.34,5.13-1.37,7.5-.09l29.59,16.06c1.65.89,2.67,2.58,2.67,4.41v7.22c0,1.8-.96,3.43-2.55,4.35-1.67.96-3.65.95-5.31-.01l-24.96-14.46c-2.02-1.17-4.46-1.22-6.52-.15-2.15,1.12-3.46,3.24-3.49,5.67Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.767,90.201v69.02c0,1.78-1,3.43-2.59,4.31l-31.33,17.19c-1.18.65-2.48.98-3.77.98-1.33,0-2.66-.34-3.86-1.03-2.37-1.34-3.81-3.77-3.84-6.49-.03-2.73,1.35-5.18,3.69-6.58l23.72-14.12c1.27-.75,2.03-2.12,1.98-3.56l-.18-5.29c-.04-1.4-.82-2.66-2.08-3.36-1.32-.74-2.89-.73-4.21.02l-39.46,22.53c-2.63,1.5-5.92,1.34-8.39-.4l-1.65-1.16c-1.31-.93-2.1-2.43-2.1-4.01v-3.55c0-1.79,1-3.44,2.6-4.31l53.68-29.32c1.3-.71,2.11-2.05,2.12-3.49l.16-30.51c.01-1.76.95-3.34,2.51-4.23,1.63-.94,3.58-.93,5.2.01l5.32,3.1c1.53.89,2.48,2.52,2.48,4.25Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.527,190.161c-.04,2.73-1.49,5.12-3.9,6.4l-.67.35c-1.13.6-2.35.9-3.58.9-1.28,0-2.56-.33-3.72-.98l-59.54-33.28c-1.59-.89-2.58-2.55-2.58-4.33v-36.65c0-1.76.98-3.42,2.54-4.31l4.83-2.75c1.63-.92,3.58-.92,5.21.01,1.56.9,2.5,2.49,2.52,4.25l.33,30.32c.02,1.46.85,2.8,2.16,3.52l4.39,2.36c1.34.73,2.93.7,4.25-.08,1.25-.73,2.01-2.02,2.02-3.44l.37-45.91c.01-1.66.87-3.2,2.29-4.12l1.58-1.02c2.45-1.58,5.54-1.64,8.05-.13l1.54.92c1.52.91,2.46,2.55,2.44,4.29l-.41,60.11c-.01,1.45.79,2.81,2.1,3.54l24.04,13.55c2.37,1.33,3.77,3.76,3.74,6.48Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagoneBasiqueReady);
export default __webpack_public_path__ + "static/media/hexagone-basique-ready.fe360f97ce2941d367282763271588b9.svg";
export { ForwardRef as ReactComponent };